import type { LineSize } from "metabase-types/api";

export const LINE_SIZE: Record<LineSize, number> = {
  S: 1,
  M: 2,
  L: 3,
};

export const Z_INDEXES = {
  brushMirror: 100,
  // Note: timeline events use echarts' markline option, which has a fixed z
  // value of 5.
  dataLabels: 8,
  goalLine: 7,
  trendLine: 7,
  lineAreaSeries: 7,
  series: 6, // Bars needs to have a lower z value than line/area series, see issue #40209
};

export const CHART_STYLE = {
  series: {
    barWidth: 0.8,
    histogramBarWidth: 0.995,
  },
  axisTicksMarginX: 5,
  axisTicksMarginY: 10,
  axisTicks: {
    weight: 400,
  },
  seriesLabels: {
    weight: 700,
    size: 13,
    offset: 4,
    stackedPadding: 2,
  },
  axisName: {
    weight: 400,
  },
  axisNameMargin: 12,
  padding: {
    x: 8,
    y: 12,
  },
  symbolSize: 6,
  timelineEvents: {
    height: 14,
    minDistance: 16,
    countLabelMargin: 4,
  },
  goalLine: {
    label: {
      margin: 4,
      size: 13,
      weight: 400,
    },
  },
  opacity: {
    blur: 0.3,
    area: 0.3,
    areaFocused: 0.6,
    areaBlurred: 0.2,
    scatter: 0.8,
  },
  brush: {
    fillOpacity: 0.1,
    borderOpacity: 0.4,
    borderWidth: 1,
  },
  splitPanel: {
    gapRatio: 2.2,
    maxGap: 48,
  },
};

export function getSplitPanelGap(panelHeight: number): number {
  return Math.min(
    panelHeight / CHART_STYLE.splitPanel.gapRatio,
    CHART_STYLE.splitPanel.maxGap,
  );
}
